import $ from "jquery"
import cssInjector from "./css_injector.js"
import libUrl from "./lib_url.js"
import Prism from "./extlibs/prism.js"

function setTheme (name) {
    cssInjector({
        file: libUrl(`extlibs/prism_${name}.css`)
    })
}

function highlight (source, language = "javascript") {
    const $element = $(`<pre><code class="language-${language}">${source}</code></pre>`)
    Prism.highlightElement($element.find("code")[0])
    return $element
}

highlight.setTheme = setTheme


export default highlight

